import { init } from "../init";
import { JiraSoftwareFreePage } from "../pages/software/jira/free/jira-software-free-page";

init(JiraSoftwareFreePage);
